import styles from './Marquee.module.css';

const ITEMS = [
  'Bridal Specialist',
  'Nationally Certified',
  'Bharatpur\'s Finest',
  '4.8★ Rated',
  'Destination Weddings',
  '25+ Years of Excellence',
  'Hundreds of Happy Clients',
  'Party & Event Makeup',
  'Pre-Bridal Packages',
  'Skincare & Facials',
];

export default function Marquee() {
  // Duplicate for seamless loop
  const doubled = [...ITEMS, ...ITEMS];

  return (
    <div className={styles.marquee} aria-hidden="true">
      <div className={styles.track}>
        {doubled.map((item, i) => (
          <span key={i} className={styles.item}>
            <span className={styles.text}>{item}</span>
            <span className={styles.dot} />
          </span>
        ))}
      </div>
    </div>
  );
}
